import { createSelector } from 'reselect';
import { getCurrentWorkOrderOp } from './getCurrentWorkOrderOp';
import { getApmCurrentOrderQuantity } from './getApmCurrentOrderQuantity';

/**
 * The current job's finish quantity. Under APM the current work order op is built from the
 * program-event feed without one, so the feed's order quantity supplies it.
 */
export const getCurrentFinishQuantity = createSelector(
  [getCurrentWorkOrderOp, getApmCurrentOrderQuantity],
  (currentWorkOrderOp, apmCurrentOrderQuantity) => {
    return (
      apmCurrentOrderQuantity?.finishQuantity ??
      currentWorkOrderOp?.finishQuantity
    );
  }
);
